var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBowlIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 15,
    viewBox: "0 0 18 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.86874 6.41853C5.80671 5.10605 14.1463 5.72276 15.9993 6.41853C16.3435 6.54777 16.8014 6.69676 16.9507 6.88179C17.0155 6.9621 17.0221 7.04921 16.9361 7.14444C16.7434 9.68587 14.9556 14.2945 9.0498 14.2945C3.09472 14.2945 1.24639 9.60863 1.03549 7.08125C0.993219 7.01319 0.988709 6.94716 1.02196 6.88179C1.0994 6.72954 1.38165 6.58087 1.86874 6.41853Z",
    fill: "#FCF8EA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.02196 6.88179C0.915238 7.09161 1.19751 7.30822 1.86874 7.57677C5.80677 8.73501 12.2929 8.68868 15.9993 7.57677C16.9345 7.29621 17.1028 7.07029 16.9507 6.88179M1.02196 6.88179C1.0994 6.72954 1.38165 6.58087 1.86874 6.41853C5.80671 5.10605 14.1463 5.72276 15.9993 6.41853C16.3435 6.54777 16.8014 6.69676 16.9507 6.88179M1.02196 6.88179C1.14977 9.35271 2.93427 14.2945 9.0498 14.2945C15.1653 14.2945 16.8652 9.35271 16.9507 6.88179",
    stroke: "#221122"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.88285 7.5778C5.82088 8.73604 12.307 8.68971 16.0134 7.5778C16.8038 7.34069 16.9378 7.17342 16.9603 6.98747C16.9621 6.95212 16.9636 6.91723 16.9648 6.88281C16.9648 6.91869 16.9644 6.9534 16.9603 6.98747C16.8311 9.49043 15.0943 14.2956 9.06391 14.2956C3.03332 14.2956 1.21429 9.49006 1.04237 6.98718C1.0345 6.95299 1.0327 6.91834 1.03607 6.88281C1.03785 6.91713 1.03994 6.95193 1.04237 6.98718C1.08582 7.17594 1.31456 7.35043 1.88285 7.5778Z",
    fill: "#B9CF78",
    stroke: "#221122"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5083 1.4751L10.1565 7.68215C9.98156 8.00607 10.2161 8.39934 10.5843 8.39934C10.7477 8.39934 10.9003 8.31719 10.9902 8.18071L14.8722 2.29073C15.1131 1.92532 15.0135 1.43399 14.6493 1.19123C14.2596 0.931403 13.7308 1.06295 13.5083 1.4751Z",
    fill: "#FF7800",
    stroke: "#221122"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBowlIcon);
export default __webpack_public_path__ + "static/media/bowlIcon.5389ef12a4775fd2fca0aa12334a9ad2.svg";
export { ForwardRef as ReactComponent };